import LogoScene from './scenes/LogoScene';
import GameScene from './scenes/GameScene';

import SecretSymbols from './utils/SecretSymbols';
import AssetsLoader from './utils/AssetsLoader';
import * as names from './names';
import {AudioContext} from "../docs/assets/js/vendor/three";

class App {
  constructor() {
    const assets = new AssetsLoader({
      sounds: {
        [names.SOUND_GAME_MUSIC]:        'Gamesoundtrack.mp3',
        [names.SOUND_INTERSECT_CUBE_1]:    'Bounce11.mp3',
        [names.SOUND_INTERSECT_CUBE_2]:    'Bounce22.mp3',
        [names.SOUND_INTERSECT_CUBE_3]:    'Bounce33.mp3',
        [names.SOUND_INTERSECT_PADDLE]:  'Platee.mp3',
        [names.SOUND_BOOM]:  'Boom.mp3',
        [names.SOUND_VICTORY_VOICE]:  'Meetup.mp3',
        [names.SOUND_LOSE_VOICE_1]:  'Missu.mp3',
        [names.SOUND_LOSE_VOICE_2]:  'Missu2.mp3',
        [names.SOUND_START_VOICE]:  'Try.mp3',
      },
      images: {
        [names.IMG_INTERACTOPUS_BG_BLACK]: 'interactopus-black-bg.png',
        [names.IMG_INTERACTOPUS_BG_TRANS]: 'interactopus.png',
      }
    });

    this.assets = assets;
    this.wasGameRun = false;

      const unlockAudioContext = () => {
          AudioContext.getContext()
          window.removeEventListener("click", unlockAudioContext);
          window.removeEventListener("keydown", unlockAudioContext);

          document.body.classList.remove('is-wait-for-click')

          assets.load().then(() => {
              this.init();
              this.afterInit();
          });
      }
      window.addEventListener("click", unlockAudioContext);
      window.addEventListener("keydown", unlockAudioContext);




    //
    // const menuScene = new GlitchScene({
    //   containerEl: menuEl,
    //   containerWidth: 500,
    //   containerHeight: 500,
    //   imgWidth: 1920,
    //   imgHeight: 1080,
    //   imgUrl: 'assets/images/1.png',
    // });
    //
    // const menuScene2 = new GlitchScene({
    //   containerEl: menu2El,
    //   containerWidth: 200,
    //   containerHeight: 200,
    //   imgWidth: 1920,
    //   imgHeight: 1080,
    //   imgUrl: 'assets/images/test.jpg',
    // });
  }

  init() {
    const eventLogoEl    = document.getElementById('eventLogoGlitch');
    const menu2El    = document.getElementById('menu2');
    const contentEl = document.getElementById('content');
    const locationValueEl = document.getElementById('locationValue');
    const dateValueEl = document.getElementById('dateValue');
    const timeValueEl = document.getElementById('timeValue');

    this.secretSymbolsLocation = new SecretSymbols({
      rootEl: locationValueEl,
      word: 'БВШД',
      symbols: '!@#$%^&*()qwertyuiopljhgfрарцуисчязшфцу'
    });
    this.secretSymbolsDate = new SecretSymbols({
      rootEl: dateValueEl,
      word: '20.11.2016',
      symbols: '1234567890.',
      renderType: 'date',
    });
    this.secretSymbolsTime = new SecretSymbols({
      rootEl: timeValueEl,
      word: '19:00',
      symbols: '!@#1234567890:',
      renderType: 'time',
    });
    //
    // setTimeout(() => {
    //   secretSymbolsLocation.reveal();
    //   secretSymbolsDate.reveal();
    //   secretSymbolsTime.reveal();
    // }, 2000);

    //
    this.logoScene = new LogoScene({
      rootEl: eventLogoEl,
    });
  }

  afterInit() {
    this.assets.getSound(names.SOUND_GAME_MUSIC).loop = true;
    this.assets.getSound(names.SOUND_GAME_MUSIC).play();
    setTimeout(() => {
      document.body.classList.remove('is-loading');
      document.body.classList.add('is-loaded');

      const logoEl = document.getElementById('eventLogo');
      logoEl.addEventListener('click', () => {
        if (this.wasGameRun) {
          window.location.reload();
        } else {
          this.goGame();
        }
      }, false);
    }, 1500);
  }

  goGame() {
    this.wasGameRun = true;
    const gameEl = document.getElementById('game');
    const game = new GameScene({
      rootEl: gameEl,
      assets: this.assets,
    });
    game.emitter.on(names.EVENT_FINAL_BLOCK_KILLED, () => {
      this.goVictory();
    });
    game.emitter.on(names.EVENT_NO_LIVES, () => {
      this.goLose();
    });
    document.body.classList.add('is-game');
    this.logoScene.disable();
    this.game = game;
  }

  goVictory() {
    this.game.disable();
    document.body.classList.add('is-victory');
    document.body.classList.remove('is-game');
    this.logoScene.enable();
    this.secretSymbolsLocation.reveal();
    this.secretSymbolsTime.reveal();
    this.secretSymbolsDate.reveal();
  }

  goLose() {
    this.game.disable();
    document.body.classList.add('is-lose');
    document.body.classList.remove('is-game');
    this.logoScene.enable();
  }
}

new App();



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/